module.exports = __webpack_public_path__ + "static/media/gts24.2b91bfc6.png";